import VideoDetails from 'models/VideoDetails';
const shaka = require('external/shaka-player.ui.debug');

export function loadHls(videoDetails: VideoDetails, player: any): Promise<unknown> {
  let contentId: string;

  // base config
  const playerOptions = {
    drm: {
      servers: {
        'com.apple.fps.1_0': process.env.NEXT_PUBLIC_DRM_LICENSE_URL_FAIRPLAY,
      },
      initDataTransform: (initData, initDataType) => {
        if (initDataType != 'skd') return initData;

        // 'initData' is a buffer containing an 'skd://' URL as a UTF-8 string.
        const skdUri = shaka.util.StringUtils.fromBytesAutoDetect(initData);
        contentId = skdUri.split('skd://')[1].substr(0, 32);
        const cert = player.drmInfo().serverCertificate;

        return shaka.util.FairPlayUtils.initDataTransform(initData, contentId, cert);
      },
    },
  };

  // intercept request
  player.getNetworkingEngine().registerRequestFilter((type, request) => {
    if (type != shaka.net.NetworkingEngine.RequestType.LICENSE) {
      return;
    }

    const originalPayload = new Uint8Array(request.body);
    const base64Payload = shaka.util.Uint8ArrayUtils.toStandardBase64(originalPayload);
    const params = 'spc=' + base64Payload + '&assetId=' + contentId;

    request.body = shaka.util.StringUtils.toUTF8(params);
    request.headers['x-keyos-authorization'] = videoDetails.customData;
    request.headers['Content-Type'] = 'text/plain';
  });

  // intercept response
  player.getNetworkingEngine().registerResponseFilter((type, response) => {
    if (type != shaka.net.NetworkingEngine.RequestType.LICENSE) {
      return;
    }

    let responseText = shaka.util.StringUtils.fromUTF8(response.data);
    // Trim whitespace.
    responseText = responseText.trim();

    // Decode the base64-encoded data into the format the browser expects.
    response.data = shaka.util.Uint8ArrayUtils.fromBase64(responseText).buffer;
  });

  return new Promise((resolve, reject) => {
    fetch(process.env.NEXT_PUBLIC_DRM_CERTIFICATE_URL_FAIRPLAY)
      .then((res) => res.arrayBuffer())
      .then((cert) => {
        player.configure('drm.advanced.com\\.apple\\.fps\\.1_0.serverCertificate', new Uint8Array(cert));
        player.configure(playerOptions);

        player
          .load(videoDetails.hls)
          .then(resolve)
          .catch((e) => {
            console.log(e);
            reject(e);
          });
      })
      .catch((e) => {
        console.log(e);
        reject(e);
      });
  });
}
